export enum IconVariant {
  ExclamationCircle = 'ExclamationCircle',
  Apple = 'Apple',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowRightNew = 'ArrowRightNew',
  Box = 'Box',
  CalendarUtility = 'CalendarUtility',
  CalendarOutline = 'CalendarOutline',
  CaretDown = 'CaretDown',
  CaretDownNew = 'CartDownNew',
  CaretLeft = 'CaretLeft',
  CaretRight = 'CaretRight',
  CaretUp = 'CaretUp',
  Cart = 'Cart',
  Cart2 = 'Cart2',
  Chain = 'Chain',
  Check = 'Check',
  CheckboxOff = 'CheckboxOff',
  CheckboxOn = 'CheckboxOn',
  Clock = 'Clock',
  Coin = 'Coin',
  Coin2 = 'Coin2',
  Facebook = 'Facebook',
  FilterBadge = 'FilterBadge',
  FilterBadgeActive = 'FilterBadgeActive',
  Flame = 'Flame',
  Fridge = 'Fridge',
  Gear = 'Gear',
  Google = 'Google',
  Heart = 'Heart',
  Home = 'Home',
  HomeFilled = 'HomeFilled',
  Instagram = 'Instagram',
  List = 'List',
  ListFilled = 'ListFilled',
  Lock = 'Lock',
  MagnifyingGlass = 'MagnifyingGlass',
  MagnifyingGlassFilled = 'MagnifyingGlassFilled',
  Minus = 'Minus',
  New = 'New',
  Pause = 'Pause',
  Pencil = 'Pencil',
  Pepper = 'Pepper',
  Pepper2 = 'Pepper2',
  Person = 'Person',
  PersonFilled = 'PersonFilled',
  Platter = 'Platter',
  Play = 'Play',
  PlusCircle = 'PlusCircle',
  Plus = 'Plus',
  Question = 'Question',
  RadioOff = 'RadioOff',
  RadioOn = 'RadioOn',
  Servings = 'Servings',
  Slider = 'Slider',
  Sparkle = 'Sparkle',
  StarFill = 'StarFill',
  StarOutline = 'StarOutline',
  Sunrise = 'Sunrise',
  Swap = 'Swap',
  Tag = 'Tag',
  Trash = 'Trash',
  Trash2 = 'Trash2',
  Twitter = 'Twitter',
  X = 'X',
  YouTube = 'YouTube',
  ThumbsUp = 'ThumbsUp',
  ThumbsUpFilled = 'ThumbsUpFilled',
  ThumbsDown = 'ThumbsDown',
  ThumbsDownFilled = 'ThumbsDownFilled',
  Bookmark = 'Bookmark',
  Wallet = 'Wallet',
  Information = 'Information',
  Never = 'Never',
  Checklist = 'Checklist',
  ChefHat = 'ChefHat',
  Fish = 'Fish',
  Vegan2 = 'Vegan2',
  Vegetarian2 = 'Vegetarian2',
  Truck = 'Truck',

  // Illustrated Icons
  Airfryer = 'Airfryer',
  AntiInflamitory = 'AntiInflamitory',
  BeansPlusLentils = 'Beans + Lentils',
  Beef = 'Beef',
  Beets = 'Beets',
  BellPepper = 'BellPepper',
  NoBellPepper = 'NoBellPepper',
  Blender = 'Blender',
  Breakfast = 'Breakfast',
  Burger = 'Burger',
  Calendar = 'Calendar',
  Calories = 'Calories',
  CalorieConscious = 'CalorieConscious',
  ChefsPick = "Chef's Pick",
  Chicken = 'Chicken',
  Cilantro = 'Cilantro',
  Coconut = 'Coconut',
  NoCilantro = 'NoCilantro',
  ClockIllustrated = 'Clock (Illustrated)',
  Credit = 'Credit',
  Crockpot = 'Crockpot',
  Cuisines = 'Cuisines',
  CYO = 'CYO',
  DairyFree = 'DairyFree',
  DairyFreeCheese = 'DairyFreeCheese',
  Dietary = 'Dietary',
  Dislike = 'Dislike',
  EggFree = 'EggFree',
  Eggplant = 'Eggplant',
  NoEggplant = 'NoEggplant',
  FreshFish = 'FreshFish',
  Garlic = 'Garlic',
  Gift = 'Gift',
  GlutenFree = 'GlutenFree',
  GlutenFreeBread = 'GlutenFreeBread',
  Grill = 'Grill',
  GutHealth = 'GutHealth',
  GutFriendly = 'GutFriendly',
  HighProtein = 'HighProtein',
  Immunity = 'Immunity',
  IllustrationDietary = 'IllustrationDietary',
  KidsSnacks = 'KidsSnacks',
  Lamb = 'Lamb',
  LowFodmap = 'LowFodmap',
  LowCholesterol = 'LowCholesterol',
  LowFat = 'LowFats',
  HighFiber = 'HighFiber',
  Microwave = 'Microwave',
  Mushrooms = 'Mushrooms',
  NoMushrooms = 'NoMushrooms',
  Lightbulb = 'Lightbulb',
  LowCarb = 'LowCarb',
  LowSodium = 'LowSodium',
  LowSugar = 'LowSugar',
  NewIllustrated = 'New (Illustrated)',
  Nutrition = 'Nutrition',
  Onion = 'Onion',
  NoOnion = 'NoOnion',
  Organic = 'Organic',
  Organic2 = 'Organic2',
  PeanutFree = 'PeanutFree',
  Personalized = 'Personalized',
  Pescatarian = 'Pescatarian',
  PlantBased = 'PlantBased',
  PlantBasedEgg = 'PlantBasedEgg',
  Polarizing = 'Polarizing',
  Pork = 'Pork',
  Potatoes = 'Potatoes',
  NoPotatoes = 'NoPotatoes',
  Protein = 'Protein',
  Recent = 'Recent',
  Recipe = 'Recipe',
  Shellfish = 'Shellfish',
  ShellfishFree = 'ShellfishFree',
  SmokedFish = 'SmokedFish',
  SoyFree = 'SoyFree',
  Spice = 'Spice',
  SpiceHot = 'SpiceHot',
  SpiceMedium = 'SpiceMedium',
  SpiceMild = 'SpiceMild',
  SpiceNone = 'SpiceNone',
  Stove = 'Stove',
  Tempeh = 'Tempeh',
  Tomatoes = 'Tomatoes',
  NoTomatoes = 'NoTomatoes',
  TreeNutFree = 'TreeNutFree',
  Vegan = 'Vegan',
  Vegetarian = 'Vegetarian',
  Feeds1 = 'Feeds 1',
  Feeds2 = 'Feeds 2',
  Feeds3 = 'Feeds 3',
  Feeds4 = 'Feeds 4',
  StoveTop = 'StoveTop',
  Oven = 'Oven',

  Flavors = 'Flavors',
  FreeShipping = 'Free Shipping',
  SpendMoreSaveMore = 'Spend More Save More',
  ThirtyOff = '30% Off',
  OpenBox = 'Open Box',
  Sweets = 'Sweets',
  Sweets2 = 'Sweets2',
  Snacks = 'Snacks',
  TableSetting = 'TableSetting',
  WalletIllustrated = 'WalletIllustrated',
  XCircle = 'XCircle',
  Warning = 'Warning',
  None = 'None',
  Sweets23 = 'Sweets23',
  Sweets46 = 'Sweets46',
  Sweets710 = 'Sweets710',

  SnacksLarge = 'SnacksLarge',
  SnacksMedium = 'SnacksMedium',
  SnacksSmall = 'SnacksSmall',

  SesameFree = 'SesameFree',
  GrainFree = 'GrainFree',
  GarlicFree = 'GarlicFree',
  OnionFree = 'OnionFree',
  CaffeineFree = 'CaffeineFree',
}
